import { render } from "./TabChapters.vue?vue&type=template&id=29b58396"
import script from "./TabChapters.vue?vue&type=script&lang=js"
export * from "./TabChapters.vue?vue&type=script&lang=js"
script.render = render

export default script